import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelAcceptShippingQuote} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class AcceptShippingQuoteFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId
    }
    return this.props.acceptShippingQuote(updatedValues)
      .then((response) => {
        if (response.data.acceptShippingQuote.errors.length <= 0) {
          this.props.cancelAcceptShippingQuote();
        } else {
          let errors = createValidationErrors(response.data.acceptShippingQuote.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAcceptShippingQuote();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Are you sure you want to accept the quote? Accepting this quote will lock down the packaging list and shipping labels will be downloaded from the courier. Please note that for some couriers, the creatment of shipments and labels are deferred until shipment starts."
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const REMOVE_PACKAGE = gql`
  mutation acceptShippingQuote($data: ShippingIdInput!) {
    acceptShippingQuote(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(REMOVE_PACKAGE, {
    props: ({ mutate }) => ({
      acceptShippingQuote: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelAcceptShippingQuote})(withMutation(AcceptShippingQuoteFormContainer));